import React from 'react';
import Layout from "./Layout";
import AdsAssistantChat from './AdsAssistantChat';

const SponsoredProducts = () => {
    return (
        <Layout>
            <div className="ads-page-container">
                <div className="ads-page-header">
                    <h2><i className="bi bi-bag-check"></i> Sponsored Products</h2>
                    <p>Gestiona tus campañas de productos patrocinados</p>
                </div>
                <AdsAssistantChat context="sponsored-products" />
            </div>
        </Layout>
    );
};

export default SponsoredProducts;